import { createSlice, PayloadAction } from '@reduxjs/toolkit';


const planDataSlice = createSlice({
    name: 'planData',
    initialState: {
        showPlanId:0,
    },
    reducers: {
        setShowPlanId: (state, action) => {
            state.showPlanId = action.payload;
        },
    },
});


const { reducer, actions } = planDataSlice;


export const { setShowPlanId } = actions;


export const showPlanId = (state) => {
    return state.planData.showPlanId || 0;
};


export default reducer;
